<div class="modal fade" id="kt_export_modal" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered mw-650px">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<h2 class="fw-bold m-0">Export Subscriptions</h2>
				<div id="kt_export_close" class="btn btn-icon btn-sm btn-active-icon-primary">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>
			<div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
				<form id="kt_export_form" class="form" action="#">
					<div class="fv-row mb-10">
						<label class="fs-5 fw-semibold form-label mb-5">Select Export Format:</label>
						<select data-placeholder="Select a format" data-hide-search="true" name="format" class="form-select form-select-solid">
							<option value="excell">Excel</option>
							<option value="pdf">PDF</option>
							<option value="cvs">CVS</option>
							<option value="zip">ZIP</option>
						</select>
					</div>
					<div class="fv-row mb-10">
						<label class="fs-5 fw-semibold form-label mb-5">Select Date Range:</label>
						<input class="form-control form-control-solid" placeholder="Pick a date" name="date" />
					</div>
					<div class="row fv-row mb-15">
						<label class="fs-5 fw-semibold form-label mb-5">Payment Type:</label>
						<div class="d-flex flex-column">
							<label class="form-check form-check-custom form-check-sm form-check-solid mb-3">
								<input class="form-check-input" type="checkbox" value="1" checked="checked" name="payment_type" />
								<span class="form-check-label text-gray-600 fw-semibold">All</span>
							</label>
							<label class="form-check form-check-custom form-check-sm form-check-solid mb-3">
								<input class="form-check-input" type="checkbox" value="2" checked="checked" name="payment_type" />
								<span class="form-check-label text-gray-600 fw-semibold">Visa</span>
							</label>
							<label class="form-check form-check-custom form-check-sm form-check-solid mb-3">
								<input class="form-check-input" type="checkbox" value="3" name="payment_type" />
								<span class="form-check-label text-gray-600 fw-semibold">Mastercard</span>
							</label>
							<label class="form-check form-check-custom form-check-sm form-check-solid">
								<input class="form-check-input" type="checkbox" value="4" name="payment_type" />
								<span class="form-check-label text-gray-600 fw-semibold">American Express</span>
							</label>
						</div>
					</div>
					<div class="text-center">
						<button type="reset" id="kt_export_cancel" class="btn btn-light me-3">Discard</button>
						<button type="submit" id="kt_export_submit" class="btn btn-primary">
							<span class="indicator-label">Submit</span>
							<span class="indicator-progress">Please wait...
								<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>